export default [
  {
    name: 'default',
    attribute: 'lastPublicationDate',
    highFirst: true,
    translation: 'Sorter etter',
  },
  {
    name: 'recent',
    attribute: 'lastPublicationDate',
    highFirst: true,
    translation: 'Siste',
  },
  {
    name: 'priceLow',
    attribute: 'price',
    highFirst: false,
    translation: 'Pris lav høy',
  },
  {
    name: 'priceHigh',
    attribute: 'price',
    highFirst: true,
    translation: 'Pris høy lav',
  },
  {
    name: 'mileageLow',
    attribute: 'mileage',
    highFirst: false,
    translation: 'Km.stand lav høy',
  },
  {
    name: 'mileageHigh',
    attribute: 'mileage',
    highFirst: true,
    translation: 'Km.stand høy lav',
  },
  {
    name: 'yearLow',
    attribute: 'year',
    highFirst: false,
    translation: 'År lav høy',
  },
  {
    name: 'yearHigh',
    attribute: 'year',
    highFirst: true,
    translation: 'År høy lav',
  },
];
